import AddQuantityModalView from "./addQuantityModal.html";


angular.module("materials")

    .controller("MaterialsEditCtrl", ['treeService', 'LoginService', '$scope', '$rootScope', '$state', '$timeout', '$sce', '$stateParams', 'Restangular', 'gridService', '$filter', '$translate', 'modalService', '$uibModal', 'logService',
        function (treeService, LoginService, $scope, $rootScope, $state, $timeout, $sce, $stateParams, Restangular, gridService, $filter, $translate, modalService, $uibModal, logService) {
            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("MATERIAL_WRITE");

            $scope.stateParamsId = $stateParams.id;
            $scope.buttonCancel = true;
            $scope.changesNotSaved = false;
            $scope.errorUnits = false;
            $scope.showReturnAutomatic = false;

            $scope.gridWarehouse = { warehouse_id: 1, entity_type: 'materials' };
            $scope.loadWharesouseRows = function () {
                Restangular.all('Warehouses').getList({ entity_type: "materials", entity_id: $stateParams.id }).then(function (warehouses) {
                    $scope.selectWarehouses = warehouses;
                    $scope.gridWarehouse.warehouse_id = $scope.selectWarehouses[0].id;
                });
            }

            $scope.loadWharesouseRows();

            var trusted = {};
            $scope.getPopoverContent = function (html) {
                return trusted[html] || (trusted[html] = $sce.trustAsHtml(html));
            };


            Restangular.all('Providers').getList().then(function (providers) {
                $scope.selectProviders = providers;
            });

            $scope.addMaterialFromEvent = function (options) {
                $scope.stateParamsId = "";
                $scope.is_external = options.isExternal;
                $scope.callbackClose = options.callbackClose;
                $scope.comeFromEvents = true;
                $scope.buttonCancel = false;
                $scope.configure();
            };

            $scope.configure = function () {

                $rootScope.title = $filter('translate')('materials.title');
                $scope.material = {
                    is_external: $stateParams.is_external === "true"
                };
                if (angular.isDefined($scope.is_external)) $scope.material.is_external = $scope.is_external;
                if (angular.isUndefined($stateParams.id) || $stateParams.id == "" || $scope.stateParamsId == "") {

                    $rootScope.breadcrumb = [
                        { title: $filter('translate')('materials.title'), url: "materials.list" },
                        { title: $filter('translate')('materials.title_add') },
                    ];

                } else {
                    $rootScope.breadcrumb = [
                        { title: $filter('translate')('materials.title'), url: "materials.list" },
                        { title: $filter('translate')('materials.title_edit') },
                    ];

                    Restangular.one('Materials', $stateParams.id).get().then(function (result) {
                        $scope.material = result;
                        $scope.warehouse_last = result.warehouse_id;
                        if (!$scope.material.is_returnable) {
                            $scope.showReturnAutomatic = false;
                        } else {
                            $scope.showReturnAutomatic = true;
                        }
                    });

                }
            }

            if ($state.is("materials.edit")) $scope.configure();

            $rootScope.$on("ReloadDataSelectTypeMaterials", function () {
                $scope.reloadDataSelectTypeMaterials();
            });

            $scope.reloadDataSelectTypeMaterials = function () {
                Restangular.all('MaterialsTypes').getList().then(function (types) {
                    var resultados = treeService.typesMaterialsTree(types, null, []);
                    $scope.selectTypes = resultados;
                });
            }
            $scope.reloadDataSelectTypeMaterials();

            $scope.loadGrid = function () {
                if (angular.isDefined($scope.gridOptionsMovements)) {
                    $scope.gridOptionsMovements.loadData(false);
                } else {

                    $scope.gridOptionsMovements = {
                        pdfTitle: $filter('translate')('materials.pdf_title'),
                        exporterMenuCsv: true,
                        enableGridMenu: true,
                        //gridMenuShowHideColumns: false,
                        enableSorting: true,
                        paginationPageSizes: [20, 40, 60],
                        paginationPageSize: 20,
                        rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                        onRegisterApi: function (gridApi) {
                            this.gridApi = gridApi;
                        },
                        columnDefs: [
                            { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                            { name: 'created_at', displayName: $filter('translate')('movement.date'), type: 'date', cellFilter: 'toUniversalDateCreatedAtHack | date:\'dd/MM/yyyy HH:mm\'' },
                            { name: 'event_name', displayName: $filter('translate')('material.event'), enableFiltering: true },
                            {
                                name: 'direction', field: 'direction', displayName: $filter('translate')('movement.direction'), enableHiding: false,
                                cellTemplate: '<div ng-if="row.entity.direction==\'OUT\'" class="ui-grid-cell-contents"><span class="fa fa-arrow-down" style="color:red">Saliente</span></div><div ng-if="row.entity.direction==\'IN\'" class="ui-grid-cell-contents"><span class="fa fa-arrow-up" style="color:#00AE00">Entrante</span></div>'
                            },
                            { name: 'warehouse_name', displayName: $filter('translate')('material.warehouse'), enableFiltering: true },
                            { name: 'quantity', displayName: $filter('translate')('movement.movement'), enableFiltering: true },
                            { name: 'final_quantity', displayName: $filter('translate')('movement.final_quantity'), enableFiltering: true },
                            {
                                name: 'notes', field: 'notes', displayName: $filter('translate')('general.notes'), enableHiding: false, width: 300,
                                cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope"><span><a class= "aColorBlack" popover-placement="top" popover-trigger="mouseenter" uib-popover-html="grid.appScope.getPopoverContent(row.entity.notes)" popover-append-to-body="true" >{{row.entity.notes}}</a></span></div>',
                            },

                        ],
                        getData: function (options) {
                            options.warehouse_id = $scope.gridWarehouse.warehouse_id;
                            options.entity_type = $scope.gridWarehouse.entity_type;
                            options.entity_id = $stateParams.id;

                            return Restangular.all('WarehousesMovements').getList(options);
                        }
                    };
                }
            }

            $scope.loadGrid();

            $scope.changeTab = function (warehouse_id) {
                $scope.gridWarehouse.warehouse_id = warehouse_id;
                $scope.loadGrid();
            }


            $scope.saveMaterial = function () {
                logService.debug($scope.material);
                if (angular.isDefined($scope.material.id)) {
                    $scope.material.put().then(function (result) {
                        if (angular.isDefined(result.id)) {
                            if (angular.isUndefined($scope.comeFromEvents)) {
                                toastr.success($filter('translate')('materials.edit_success'));
                            } else {
                                $scope.callbackClose('cancel');
                            }
                        }
                    });
                } else {
                    Restangular.all('Materials').post($scope.material).then(function (result) {
                        if (angular.isDefined(result.id)) {
                            toastr.success($filter('translate')('gifts.save_success'));
                            $scope.material = result;
                            $stateParams.id = result.id;
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });
                }
            }

            $scope.checkDelete = function () {
                modalService.confirm({
                    title: $filter('translate')('materials.button_delete'),
                    message: $filter('translate')('materials.delete_message') + " " + $scope.material.name + "?",
                    onAccept: function () {
                        $scope.material.remove().then(function () {
                            toastr.success($filter('translate')('materials.delete_success'));
                            $state.go("materials.list");
                        });
                    }
                });
            };

            $scope.automaticMovement = function () {
                Restangular.all('Materials/AutomaticMovement').post().then(function () {
                });
            }


            $scope.addQuantities = function () {
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: AddQuantityModalView,
                    size: "sm",
                    controller: "AddQuantitiesMaterialsModalCrl",
                    resolve: {
                        materialId: function () { return $stateParams.id }
                    }
                });

                // Response del modal
                $modalInstance.result.then(function (movement) {
                    Restangular.all('WarehousesMovements').post(movement).then(function (res) {
                        toastr.success($filter('translate')('materials.edit_success'));
                        Restangular.one('Materials', $stateParams.id).get().then(function (result) {
                            $scope.material = result;
                            $timeout(function () {
                                $scope.loadWharesouseRows();
                                $scope.loadGrid();
                            }, 200);
                        });
                    });
                }, function () { });
            }


            $scope.changeCheckReturnable = function (item) {
                if (item) {
                    $scope.showReturnAutomatic = true;
                } else {
                    $scope.showReturnAutomatic = false;
                    $scope.material.is_returnable_automatic = false;
                }
            }

        }])

    .controller("AddQuantitiesMaterialsModalCrl", ['$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', '$http', '$stateParams', '$q', 'materialId', function ($scope, $uibModalInstance, Restangular, modalService, $filter, $http, $stateParams, $q, materialId) {

        $scope.movement = { wharehouse_id: null, quantity: 0 };
        $scope.selectWarehouses = [];
        Restangular.all('Warehouses').getList().then(function (warehouses) {
            $scope.selectWarehouses = warehouses;
        });

        $scope.onSave = function () {

            Restangular.all('Warehouses').customGET("GetTotalStockInWarehouse", { warehouse_id: $scope.movement.warehouse_id, product_id: materialId, type: "materials" }).then(function (res) {
                $scope.totalStock = res;
                //Comprobamos con los numeros negativos que no pongan menos cantidad de la que hay
                if ($scope.movement.quantity < 0) {
                    if (parseInt($scope.movement.quantity) < $scope.totalStock * -1) {
                        $scope.errorUnits = true;
                    }
                    else
                        $scope.errorUnits = false;
                }

                if (!$scope.errorUnits) {
                    let movement = {
                        material_id: materialId,
                        warehouse_id: $scope.movement.warehouse_id,
                        direction: $scope.movement.quantity > 0 ? 'IN' : 'OUT',
                        quantity: $scope.movement.quantity,
                        notes: $scope.movement.notes
                    }
                    $uibModalInstance.close(movement);
                }
            });
        }

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };


    }])


    ;

